import Enllac from 'components/corporatiu/Enllac';
import Icona from 'components/corporatiu/Icona';
import __isEmpty from 'lodash/isEmpty';
import styles from './capcaleraLite.module.scss';

const CapcaleraLite = (props) => {
    const { id, titol, routePath } = props;
    const route = {
        type: routePath,
        slug: titol,
        id
    };

    return !__isEmpty(id) ? (
        <Enllac route={route} dataTestId='tornaEnrere' className={styles.capcaleraLite}>
            <Icona
                icona='fletxa_simple_esquerra'
                path='corporatiu'
                alt='Tornar'
                className={styles.fletxa}
                mida={28}
                isBlanc={false}
            />
            <span className={styles.titol}>{titol}</span>
        </Enllac>
    ) : (
        <></>
    );
};

export default CapcaleraLite;
